import { useEffect, useState, useCallback } from "react";
import { createContext } from "react";
import { setExpiredHandler, setAuthToken } from "../util/customAxios";
import { readStoredUser } from "../util/authSession";
import { resetChatSession } from "../util/chatSession";

export const UserContext = createContext(null);

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = readStoredUser();
    if (stored?.token) setAuthToken(stored.token);
    return stored;
  });

  const login = (userData) => {
    if (userData?.token) setAuthToken(userData.token);
    setUser(userData);
  };
  const logout = () => {
    setUser(null);
    setAuthToken(null);
    localStorage.removeItem("futureOfTV_User");
    resetChatSession();
  };

  const forceExpired = useCallback(() => {
    setUser((prev) => (prev ? { ...prev, membership_expired: true } : prev));
  }, []);

  useEffect(() => {
    setExpiredHandler(forceExpired);
  }, [forceExpired]);

  useEffect(() => {
    if (user?.token) setAuthToken(user.token);
    if (user) {
      localStorage.setItem("futureOfTV_User", JSON.stringify(user));
    }
  }, [user]);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        login,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
